import styled, { css } from 'styled-components';

interface IProps {
  sizeDisplay: 'lg' | 'sm' | 'md';
  error?: boolean;
  haveMargin: boolean;
}

export const Label = styled.label`
  color: #424242;
`

export const Container = styled.div<IProps>`
  position: relative;

  ${(props) =>
    props.haveMargin === true ?
      css`
        padding: 5px 0 5px 0;
        margin: 0 1.8% 0 1.8%;
      `
      : css`
      padding: 5px 14px 5px 0;
    `

  }

  display: flex;

  border: 1px solid
    ${({ theme, error }) =>
    !error ? theme.colors.gray[400] : theme.colors.attention};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};

  ${(props) =>
    props.sizeDisplay === 'lg'
      ? css`
          width: 100%;
        `
      : props.sizeDisplay === 'md'
        ? css`
          width: calc(100% / 2 - 8px);
        `
        : css`
          width: calc(100% / 3 - 11px);
        `}
`;

export const Select = styled.select`
  border: none;
  outline: none;
  width: 100%;

  padding: 7px 2px 7px 16px;

  font-weight: 400;
  font-size: 12px;
  line-height:24px;
  color: ${({ theme }) => theme.colors.gray[500]};
  background: #fff;
`;

export const Error = styled.div`
  position: absolute;
  margin: 0;
  line-height: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.attention} !important;
  bottom: -16px;
  height: fit-content;
  left: 16px;
  height: fit-content;
`;